import React from 'react';

import { Row, Col, Modal, Button, Badge, Card } from 'react-bootstrap';
import DirectoryService from 'components/app/directory/DirectoryService';
import Avatar from 'components/common/Avatar';
import defaultAvatar from 'assets/img/team/avatar.png';
import { useEffect, useState } from 'react';
import OnBoardingService from 'components/app/directory/OnBoardingService';
import { useNavigate } from 'react-router-dom';
import useHeaderGenerator from 'components/app/common/functions/useHeaderGenerator';
import OnboardingWidgetItem from './OnboardingWidgetItem';
const OnboardingDashboard = () => {
  useEffect(() => {
    DirectoryService.retrieveUsersByAccount().then(profiles => {
      const employeeObj = Object.fromEntries(
        profiles.map(emp => [emp.identifier, emp])
      );
      setEmployees(employeeObj);

      const profile = DirectoryService.retrieveLoggedProfile();
      DirectoryService.retrieveToDoList().then(tasks => {
        const onboardingTasks = tasks.filter(task => task.onboardingTask);
        const generatedTasks = onboardingTasks.map(item => ({
          id: item.identifier,
          task: item.title,
          title: item.title,
          priority: item.priority,
          dueDate: item.dueDate,
          employeeName: profile.firstName + ' ' + profile.lastName,
          employeeIdentifier: profile.identifier,
          profileIdentifier: item.profile_identifier,
          employee: employees[item.employeeIdentifier],
          done: false,
          type: item.type,
          status: item.status,
          text: item.text,
          onboardingTask: true,
          documents: item.documents || []
        }));
        console.log('generatedTasks:', generatedTasks);
        setTasks(generatedTasks);
      });
    });
  }, []);
  const [tasks, setTasks] = React.useState([]);
  const [employees, setEmployees] = React.useState({});
  const buttonsConf = [];

  const documentPageDescription =
    'Track and manage employee onboarding progress with ease through our Onboarding Dashboard. Gain full visibility into each employee’s onboarding journey by monitoring the status of assigned tasks in real time. From document completion to training milestones, this centralized view helps ensure nothing is missed. Improve coordination, streamline processes, and provide a smooth onboarding experience by keeping every step organized and on track.';
  const headerGenerated = useHeaderGenerator(
    'Onboarding Management',
    documentPageDescription,
    buttonsConf
  );
  return (
    <>
      {headerGenerated}
      <Card className="h-100">
        <Card.Header>
          <h6 className="fs-0 text-capitalize">Onboarding Tasks</h6>
        </Card.Header>
        <Card.Body className="p-0 overflow-hidden" id="todoList">
          {tasks.length > 0 ? (
            tasks.map(item => (
              <OnboardingWidgetItem key={item.id} task={item} />
            ))
          ) : (
            <p className="text-center my-3">No onboarding tasks found.</p>
          )}
        </Card.Body>
      </Card>
    </>
  );
};

export default OnboardingDashboard;
